/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect } from 'react';
import GlobalStyles from 'styles/GlobalStyles';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from 'components/common/Header';
import Splash from 'pages/Splash';
import Home from 'pages/Home';
import { ThemeProvider } from 'styled-components';
import theme from 'styles/theme';
import BottomSheet from 'components/common/BottomSheet';
import SignUp from 'pages/SignUp';
import Login from 'pages/Login';
import Guide from 'pages/Guide';
import EditAccount from 'pages/EditAccount';
import ForgotAccount from 'pages/ForgotAccount';
import ResetPhone from 'pages/ResetPhone';
import Setting from 'pages/Setting';
import Mypage from 'pages/Mypage';
import ResetPassword from 'pages/ResetPassword';
import ForgotPassword from 'pages/ForgotPassword';
import WithdrawlAccount from 'pages/WithdrawlAccount';
import useAuthStore from 'store/auth';
import useModalStore from 'store/modal';
import CustomModal from 'components/common/Modal';
import NavigationBar from 'components/common/NavigationBar';
import QuickAction from 'components/common/QuickAction';

function App() {
  const authStore = useAuthStore();
  const isLoggedIn = authStore?.token ? true : false;
  const modalStore = useModalStore();

  const handleBeforeInstallPrompt = event => {
    event.preventDefault();

    modalStore.openModal({
      content: <div>바탕화면에 앱을 설치하시겠습니까?</div>,
      buttonCallback: async () => {
        if (!event) {
          return;
        }
        event.prompt();
        await event.userChoice;
      },
      buttonText: '확인',
    });
  }

  useEffect(() => {
    if (window.matchMedia('(display-mode: browser)').matches) {
      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      if (isIOS) {
        modalStore.openModal({
          content: (
            <div>
              <p>이 앱을 바탕화면에 추가하려면</p>
              <p>하단의 공유 버튼을 눌러 '홈 화면에 추가'를 선택하세요.</p>
            </div>
          ),
          buttonCallback: () => {
            // 모달을 닫는 함수 호출
            modalStore.closeModal();
          },
          buttonText: '확인',
        });
      }

      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

      return () => {
        window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      };
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Header />
      <CustomModal />
      <Suspense fallback={<Splash />}>
        <Routes>
          {isLoggedIn ? (
            <>
              <Route path="/" element={<Navigate replace to="/home" />} />
              <Route
                path="/home"
                element={<Navigate replace to="/home/refill" />}
              />
              <Route path="/home/:page" element={<Home />} />
              <Route path="/setting" element={<Setting />} />
              <Route path="/my" element={<Mypage />} />
              <Route path="/password/reset" element={<ResetPassword />} />
              <Route path="/account/edit" element={<EditAccount />} />
              <Route path="/phone/reset" element={<ResetPhone />} />
              <Route path="/account/withdraw" element={<WithdrawlAccount />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Navigate replace to="/login" />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/login" element={<Login />} />
            </>
          )}
          <Route path="/guide" element={<Guide />} />
          <Route path="/account/forgot" element={<ForgotAccount />} />
          <Route path="/password/forgot" element={<ForgotPassword />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
      <QuickAction />
      <BottomSheet />
      <NavigationBar />
    </ThemeProvider>
  );
}

export default App;
